import React from "react";
import PropTypes from "prop-types";
import { getGtmEventClickData } from "./../../utilities/client/analytics";
import styled from "styled-components";

export const TextLink = ({
  index = 0,
  context = null,
  clientContext = null,
  key = "text-link",
  id = "text-link",
  schema = null,
  title = null,
  linkPath = null,
  eventCardTitle = null,
  StyledLink = null,
}) => {
  let { isMobile, isTablet } = clientContext;

  const StyledSpan = styled.span`
    &:hover {
      cursor: pointer;
    }
  `;

  return (
    <StyledLink
      href={linkPath}
      onClick={(e) => {
        // console.log(e);
        e.preventDefault();
        getGtmEventClickData(e.currentTarget);
      }}
      data-track-hit-type={"event"}
      data-track-event-category={eventCardTitle}
      data-track-event-action={"click"}
      data-track-event-label={linkPath}
      data-track-event-value={6}
      data-track-redirect={true}
      clientContext={clientContext}
    >
      <StyledSpan dangerouslySetInnerHTML={{ __html: title }} />
    </StyledLink>
  );
};

const TruncateBody = (str, length, ending) => {
  if (str.length > length) {
    return str.substring(0, length) + ending;
  } else {
    return str;
  }
};

export default TextLink;

TextLink.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
  /**

  */
  index: PropTypes.number,
  /**

  */
  key: PropTypes.string,
  /**

  */
  id: PropTypes.string,
  /**

  */
  schema: PropTypes.string,
  /**

  */
  title: PropTypes.string,
  /**

  */
  linkPath: PropTypes.string,
};
